import TextField from "@material-ui/core/TextField";
import {Grid} from "@material-ui/core";
import React from "react";
import InputRules from "./InputRules";
import GridItemInput from "./GridItemInput";

interface AtLeastGateInputProps extends GridItemInput {
  k: number;
  maxK: number;
  onKChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  onKError: (error: boolean) => void;
}

class AtLeastGateInput extends React.Component<AtLeastGateInputProps> {

  private handleKChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { onKChange, onKError, maxK } = this.props;
    onKChange(e);
    onKError(!InputRules.isNonNegativeInteger(e.target.value) || maxK < Number(e.target.value));
  };

  render() {

    const { k, maxK, gridItemProps } = this.props;

    const isKValid = InputRules.isNonNegativeInteger(k.toString()) && Number(k) <= maxK;

    return (
      <Grid {...gridItemProps} item>
        <TextField
          label="K"
          value={k}
          onChange={this.handleKChange}
          margin="normal"
          type="number"
          fullWidth
          variant="filled"
          error={!isKValid}
          helperText={isKValid ? undefined : InputRules.DESCRIPTIONS.K}
        />
      </Grid>
    );
  }
}

export default AtLeastGateInput;
